import React, { useContext } from "react";
import './Footer.scss'
import Logo from 'components/Logo';
import Newsletter from 'components/Newsletter';
import { SettingsContext } from 'Providers/SettingsProvider';
import Utils from 'utils/Utils';
import {ReactComponent as Insta} from './insta.svg';
import {ReactComponent as In} from './in.svg';

function Footer() {
  const { t, screenSize } = useContext(SettingsContext);
  return <div className='footer'>
    <div className='bb active'>
      <Logo variant='blanc' link={false}/>
      <div className='desc'>{Utils.parseWithLinks(t('footer-bb','html'))}</div>
    </div>
    {screenSize!=='xs' && <div className='separateur'></div>}
    <div className='reseaux'>
      <Newsletter/>
      <div className='rs'>
        <a href={t('url-in')} target="_blank" rel="noreferrer"><In/></a>
        <a href={t('url-insta')} target="_blank" rel="noreferrer"><Insta/></a>
      </div>
    </div>
  </div>;
}
export default Footer;
